import React, { Component } from 'react';
import './logoSection.css';
import DesignSection from './designSection';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';

export default class PowerpointSection extends Component {
  render() {
    return (
      <div className="sectionContainer full-width">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="Slides" />
        <SectionPageHeader description="Our slide templates are designed to make every presentation feel on-brand with minimal effort. Always start from an approved template to ensure consistency in layout, typography, and color." />
        <DesignSection
          title={'YipitData Template'}>
          <div className="small-bottom-margin">
            <div className="no-top-padding">
              <div className="row">
                <div
                  className="small-12 medium-10 full-height">
                  <img src={'/design/google-slides-library.png'} className="full-width small-bottom-margin" alt="Powerpoint library" />
                  <p className="subheading tiny-bottom-margin">{'To use this template, click the link below, then select "YipitData Master Deck" from the template gallery. This will make a copy of the entire presentation. Delete whatever slides you do not need.'} </p>
                  <a className="downloadText" href="https://docs.google.com/presentation/u/0/?tgif=d&ftv=1" target="_blank">
                    Google Slides Library
                    <span className="material-symbols-rounded">open_in_new</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </DesignSection>
        <DesignSection
          title={'Spendhound Template'}>
          <div className="small-bottom-margin">
            <div className="no-top-padding">
              <div className="row">
                <div
                  className="small-12 medium-10 full-height">
                  <img src={'/design/spendhound-google-slides-library.png'} className="full-width small-bottom-margin" alt="Powerpoint library" />
                  <p className="subheading tiny-bottom-margin">{'To use this template, click the link below, then select "Spendhound Master Deck" from the template gallery. This will make a copy of the entire presentation. Delete whatever slides you do not need.'} </p>
                  <a className="downloadText" href="https://docs.google.com/presentation/u/0/?tgif=d&ftv=1" target="_blank">
                    Google Slides Library
                    <span className="material-symbols-rounded">open_in_new</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </DesignSection>
      </div>
    );
  }
}
